import { render, staticRenderFns } from "./headerOrdos.vue?vue&type=template&id=ddf4e0ee&scoped=true"
import script from "./headerOrdos.vue?vue&type=script&lang=js"
export * from "./headerOrdos.vue?vue&type=script&lang=js"
import style0 from "./headerOrdos.vue?vue&type=style&index=0&id=ddf4e0ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf4e0ee",
  null
  
)

export default component.exports